// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"522":"36c4da29","558":"46186ff9","739":"41ef8041","817":"57b0588d","889":"72992d22","917":"33077e71"}[chunkId] + ".chunk.js";
};